<script>
	import tableBase from '@_system/components/base/table.vue'

	export default {
		extends: tableBase,
		props: {

		},
		data() {
			return {
				gridKey: Math.random(),
				gridOptions: null,
				footerField: [{
						field: 'num',
						toFixed: 4
					},
					{
						field: 'amount',
						toFixed: 4
					},
				]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

			beforeCreateGrid(formConfig, columns, gridOptions) {
				gridOptions.showFooter = true
				gridOptions.footerMethod = this.footerMethod,
				gridOptions.footerCellClassName = this.footerCellClassName,
				gridOptions.cellStyle = this.cellStyle,


				columns.forEach((item) => {
					if (item.field == 'num') {
						item.editRender.events = {
							change: ({
								row
							}) => {
								this.numChange(row, 'num')
							}
						}
					}
					if (item.field == 'price') {
						item.editRender.events = {
							change: ({
								row
							}) => {
								this.priceChange(row, 'price')
							}
						}
					}
					if (item.field == 'amount') {
						item.editRender.events = {
							change: ({
								row
							}) => {
								this.amountChange(row, 'amount')
							}
						}
					}
				})
			},
			numChange(row, type) {
				this.amountformatter(row, type)
			},
			priceChange(row, type) {
				this.amountformatter(row, type)
			},
			amountChange(row, type) {
				this.amountformatter(row, type)
			},
			amountformatter(row, type) {
				let computefield = null
				let hasvalue = []
				let fields = [{
					field: "num",
					value: null
				}, {
					field: "price",
					value: null
				}, {
					field: "amount",
					value: null
				}]
				fields.forEach((item) => {
					item.value = row[item.field]
					if (item.value) {
						hasvalue.push(item.field)
					}
				})

				if (hasvalue.length == 2) {
					fields.forEach((item) => {
						let index = hasvalue.findIndex((_item) => {
							return item.field == _item
						})
						if (index === -1) {
							computefield = item.field
						}
					})
					if (computefield == 'amount') {
						row.amount = (row.price * row.num).toFixed(2)
					} else {
						let other = hasvalue.find((item) => {
							return item != 'amount'
						})
						if(other=='num'){
							row.price = (row.amount / row.num).toFixed(4)
						}
						if(other=='price'){
							row.num = (row.amount / row.price).toFixed(3)
						}						
						
					}
					//console.log(hasvalue, type, computefield)
				}
				if(hasvalue.length == 3){
					if(type=='num' || type=='amount'){
						row.price = (row.amount / row.num).toFixed(4)
					}
					if(type=='price'){
						row.num = (row.amount / row.price).toFixed(3)
					}			
				}
				this.$refs[this.gridref].updateFooter()
			},
			sum(field, data, toFixed) {
				let sum = 0
				data.forEach((item) => {
					for (let i in item) {
						if (i == field) {
							if (field == 'num') {
								if (!isNaN(parseFloat(item[i]))) {
									sum = sum + (parseFloat(item[i]) < 0 ? 0 : parseFloat(item[i]))

								}
							} else {
								sum = sum + (isNaN(parseFloat(item[i])) ? 0 : parseFloat(item[i]))
							}

						}
					}
				})

				this.$emit('sumChange', {
					field: field,
					sum: sum
				})

				return sum.toFixed(toFixed)
			},
			cellStyle({
				row,
				column
			}) {
				if (row.num < 0) {
					if (column.property !== 'cost') {
						return {
							color: '#F56C6C',
							backgroundColor: 'rgb(254, 240, 240)'
						}
					}
				}
				if (column.property === 'cost') {
					if (Number(row.price) >= Number(row.cost)) {
						return {
							backgroundColor: '#67C23A',
							color: '#ffffff'
						}
					} else {
						return {
							backgroundColor: '#F56C6C',
							color: '#ffffff'
						}
					}
				}
			}
		},
		components: {

		}
	}
</script>
